export default "__VITE_ASSET__8b3b19af__"